document.addEventListener('DOMContentLoaded', function() {

  /*** ===== Mobile Slider ===== ***/
  const slider = document.getElementById('mobile-slider');
  const sliderNav = document.getElementById('slider-nav');
  const cards = document.querySelectorAll('.mobile-slider-card');

  let cardWidth = 0; // Cache card width
  let dots = [];     // Cache dot elements

  function initializeSlider() {
    if (!slider || !sliderNav || cards.length === 0) return;

    if (window.innerWidth > 768) {
      sliderNav.innerHTML = '';
      return;
    }

    // Cache width once
    cardWidth = cards[0].offsetWidth + 12;

    // Clear previous dots
    sliderNav.innerHTML = '';
    dots = [];

    // Create dots
    cards.forEach((_, index) => {
      const dot = document.createElement('div');
      dot.className = `slider-dot ${index === 0 ? 'active' : ''}`;
      dot.addEventListener('click', () => {
        slider.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
      });
      sliderNav.appendChild(dot);
      dots.push(dot);
    });

    // Scroll handler with debouncing
    let scrollTimeout;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const activeIndex = Math.round(slider.scrollLeft / cardWidth);
        dots.forEach((dot, index) => dot.classList.toggle('active', index === activeIndex));
      }, 50);
    });
  }

  initializeSlider();

  // Reinitialize on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initializeSlider();
    }, 250);
  });

  /*** ===== Product Variant Updates ===== ***/
  function updateProductInfo(productId, selectedOption) {
    const variantId = selectedOption.value;
    const price = parseInt(selectedOption.dataset.price);
    const comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice) : 0;
    const available = selectedOption.dataset.available === 'true';

    const productCards = document.querySelectorAll(`[data-product-id="${productId}"]`);

    productCards.forEach(card => {
      // Update price
      const priceEl = card.querySelector('.current-price');
      if (priceEl) {
        priceEl.textContent = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(price / 100);
        priceEl.setAttribute('data-price', price);
      }

      // Update compare price & discount
      const originalPriceEl = card.querySelector('.original-price');
      const discountBadgeEl = card.querySelector('.discount-badge');

      if (comparePrice && comparePrice > price) {
        if (originalPriceEl) {
          originalPriceEl.textContent = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(comparePrice / 100);
          originalPriceEl.style.display = 'inline';
        }

        if (discountBadgeEl) {
          discountBadgeEl.textContent = `${Math.round(((comparePrice - price) / comparePrice) * 100)}% OFF`;
          discountBadgeEl.style.display = 'inline';
        }
      } else {
        if (originalPriceEl) originalPriceEl.style.display = 'none';
        if (discountBadgeEl) discountBadgeEl.style.display = 'none';
      }

      // Update hidden variant input
      const hiddenInput = card.querySelector('.product-variant-id');
      if (hiddenInput) hiddenInput.value = variantId;

      // Update button state
      const button = card.querySelector('.bestseller-add-to-cart');
      const buttonText = button?.querySelector('span');

      if (button && buttonText) {
        if (available) {
          button.disabled = false;
          button.removeAttribute('disabled');
          buttonText.textContent = button.closest('form')?.dataset.addToCartText || 'Add to cart';
        } else {
          button.disabled = true;
          button.setAttribute('disabled', 'disabled');
          buttonText.textContent = 'Sold out';
        }
      }
    });
  }

  document.querySelectorAll('.variant-dropdown').forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const selectedOption = this.options[this.selectedIndex];

      updateProductInfo(productId, selectedOption);

      // Sync other dropdowns for the same product
      document.querySelectorAll(`[data-product-id="${productId}"] .variant-dropdown`).forEach(otherSelect => {
        if (otherSelect !== this) otherSelect.value = this.value;
      });
    });
  });

  // Store original button text
  document.querySelectorAll('.bestseller-add-to-cart').forEach(button => {
    const form = button.closest('form');
    if (form) {
      const buttonText = button.querySelector('span');
      if (buttonText) form.dataset.addToCartText = buttonText.textContent.trim();
    }
  });

  /*** ===== Product Ratings ===== ***/
  window.productRatings = {
    "Gorakhpur Kalanamak Rice": { reviews: 150, rating: 4.7 },
    "Kashmiri Mamra": { reviews: 133, rating: 4.7 },
    "Kashmiri Walnuts": { reviews: 107, rating: 4.8 },
    "Chambal Desi Cow Ghee": { reviews: 94, rating: 4.8 },
    "Rajasthani Kachi Ghani Mustard Oil (Black)": { reviews: 91, rating: 4.8 },
    "Premium Idukki Cardamom": { reviews: 86, rating: 4.8 },
    "Rajasthani Kachi Ghani Mustard Oil (Yellow)": { reviews: 85, rating: 4.7 },
    "Premium Pampore Saffron": { reviews: 79, rating: 4.7 },
    "Nashik Black Raisins": { reviews: 79, rating: 4.7 },
    "Rajasthani Cold Pressed Groundnut Oil": { reviews: 77, rating: 4.7 }
  };

  const allProductCards = document.querySelectorAll(".product-card, .mobile-slider-card");

  allProductCards.forEach(card => {
    const title = card.querySelector(".product-title a")?.innerText?.trim();
    const ratingData = window.productRatings[title];
    if (ratingData) {
      const ratingSection = card.querySelector(".rating-stars");
      if (ratingSection) {
        ratingSection.innerHTML = `
          <span class="star-icon">★</span>
          <span class="rating-number">${ratingData.rating.toFixed(1)}</span>
          <span class="review-count">(${ratingData.reviews} Reviews)</span>
        `;
      }
    }
  });

  console.log('Bestsellers section fully optimized for mobile & performance');

});
